import { getLatestDate, wasDateWithinLastDay } from 'dateUtils';
import { COLOR_VARIANT } from 'models/Colors';
import {
  DataRoomRFICategory,
  DATA_ROOM_RFI_UPLOAD_STATUS,
  FileTypeRFI,
} from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { RFI_LIST_STATUS_FILTER_ALL } from 'router/subrouters/DataRoom/providers/Rfi/Rfi.context';
import { EMPTY_ARRAY } from 'data/global';

export const UPLOAD_STATUS_COLOR = {
  [DATA_ROOM_RFI_UPLOAD_STATUS.UPLOADED]: COLOR_VARIANT.GREEN,
  [DATA_ROOM_RFI_UPLOAD_STATUS.NOT_UPLOADED]: COLOR_VARIANT.RED,
};

export const UPLOAD_STATUS_LABEL_KEYS = {
  [DATA_ROOM_RFI_UPLOAD_STATUS.UPLOADED]: 'uploaded',
  [DATA_ROOM_RFI_UPLOAD_STATUS.NOT_UPLOADED]: 'notUploaded',
};

export const UPLOAD_STATUS_FILTER_LABEL_KEYS = {
  [RFI_LIST_STATUS_FILTER_ALL]: 'allStatuses',
  [DATA_ROOM_RFI_UPLOAD_STATUS.UPLOADED]: 'uploaded',
  [DATA_ROOM_RFI_UPLOAD_STATUS.NOT_UPLOADED]: 'notUploaded',
};

export const getLatestUploadedFile = (files: FileTypeRFI[]) =>
  (files || []).reduce(
    (latest, file) =>
      !latest || +new Date(file.createdAt) > +new Date(latest.createdAt)
        ? file
        : latest,
    undefined,
  );

export const getCategoryWasReminderSentRecently = (
  category: DataRoomRFICategory,
) =>
  wasDateWithinLastDay(
    getLatestDate(
      (category?.reminders || EMPTY_ARRAY).map(({ sentAt }) => sentAt),
    ),
  );

export const getSortedCategoryFiles = (files: FileTypeRFI[]) =>
  [...(files || EMPTY_ARRAY)].sort(
    (a, b) => +new Date(b.createdAt) - +new Date(a.createdAt),
  );
